export default __webpack_public_path__ + "locales/es/FilesSettings.json?hash=c305aafc8a37eb59a86bd34558a9a996";